// eslint-disable-next-line
import React from 'react';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { carinaFontReset } from './styleHelper';

const RadioGroupPrimitive = ({
  children,
  testID,
  id,
  inline,
  accessibilityLabel,
  describedBy,
  theme,
  isRtl,
  style,
  ...restProps
}) => (
  <ul
    {...restProps}
    id={id}
    css={getListStyles(theme, isRtl)}
    role="radiogroup"
    aria-label={accessibilityLabel}
    aria-describedby={describedBy}
    {...injectTestId(testID)}
  >
    {children}
  </ul>
);

function getListStyles(theme, isRtl) {
  return {
    ...carinaFontReset(theme),
    boxSizing: 'border-box',
    clear: 'both',
    color: theme.font.color.base,
    display: 'block',
    fontSize: theme.font.base.size.s,
    listStyleType: 'none',
    margin: 0,
    outline: 0,
    padding: 0,
    textAlign: isRtl ? 'right' : 'left',
    direction: isRtl ? 'rtl' : 'ltr'
  };
}

export default RadioGroupPrimitive;
